export default __webpack_public_path__ + "static/media/NotherSunset.7e453367.jpg";